export default {
    namespaced: true,
    state: {
        balanceSheetFilter: {}
    },
    getters: {
        getBalanceSheetFilter: state => state.balanceSheetFilter
    },
    mutations: {
        setBalanceSheetFilter (state, balanceSheetFilter) {
            state.balanceSheetFilter = balanceSheetFilter;
        }
    }
}